const lineWidth = 10;
const typeSpeed = 0.1;



function containerSkewClose( menuContainer, beforeCloseCallback = null, afterCloseCallback = null  ) {

  if( beforeCloseCallback != null ) {
    if(( beforeCloseCallback.then || null ) == null ){
      beforeCloseCallback.then( function(){
        containerSkewClose( menuContainer, null, afterCloseCallback );
      }.bind(this));
      return; 
    }
    beforeCloseCallback();
  }
  const mc   = menuContainer;
  const wh   = window.innerHeight;
  const ww   = window.innerWidth;
  const deg = ( 90 - Math.atan2(wh,ww)/Math.PI*180 );
  const initialMenuPos = Math.floor( wh / 2 );
  const rightStart = ww * 3  -  5;
  const rightEnd   = ww / 2 - 5;
  const left = ( ww  - lineWidth ) / 2 


  mc.css({   
    top  : "0px",
    width: "300%",
    height: "100%",
    transformOrigin: "center center",
    left: - ww + "px",
    "transform":  'skewX(' + deg + 'deg)'
  });

  mc.velocity(
    { 
      "left": left + "px",
      "width": lineWidth + "px"
    },
    {
      duration: 400,
      easing: 'easeInCirc',
      complete: function(){
        mc.css(
          {
            transformOrigin: "top left",
            left: "0px",
            top: "0px"
          });
        mc.velocity({
            height: "0px"
         }, {
          complete: function(){
            // mc.attr("style", "opacity: 0");
            // mc.velocity('stop')
          }
         });
      }

    }
  );

}

function prepareTypingEffect( elm, text ) {
  console.info("applying detail menu to " + text );
  elm.classList.add('type-simulator');
  Array.from( text ).forEach( ( w, index ) => {
    var span = document.createElement('span');
    span.innerHTML = w;
    span.style.transitionDelay = ( typeSpeed * index ) + "s";
    elm.appendChild( span );
  } );
}



function containerSkewFadeout( menuContainer, milisecond, beforeFadeoutCallback = null, afterFadeoutCallback = null ) {
  const debug = true;
  const mc   = menuContainer;
  const ww   = window.innerWidth;
  const left = ( ww  - lineWidth ) / 2;
  if( debug == true )
  {
    console.log('working on the second fadeOut');
    menuContainer.velocity( 
      { opacity: 0 },
      {
        duration: milisecond, 
        complete: function(){
            // mc.velocity("stop");
            mc[0].style.transform =  null;
            mc[0].style.height    =  "0%";
            mc.velocity({
              height:"0%",
              left:"0px",
              top:"0px",
              width: lineWidth
            }, { 
              duration: 0
            })
            console.info('fadeOut happened ');
            if( afterFadeoutCallback ) {
              afterFadeoutCallback();
            }
        }
      });
    return;
  }

  if( beforeFadeoutCallback != null ) {
    if(( beforeFadeoutCallback.then || null ) == null ){
      beforeFadeoutCallback.then( function(){
        containerSkewFadeout( menuContainer, null, afterFadeoutCallback );
      }.bind(this));
      return; 
    }
    beforeFadeoutCallback();
  }

  mc.css({
    left : "0px",   
    top  : "0px",
    width: "100%",
    height: "100%",
    opacity: 1
  });
  mc.velocity(
    { 
      "opacity": 0
    }, {

      duration: milisecond,
      easing: 'easeInCirc',
      complete: function(){
        mc.css(
          {
            transformOrigin: "top left",
            left: "0px",
            top: "0px",
            opacity: 0
          });
        mc.velocity({
            height: "0px",
            width: lineWidth + "px"
         }, {
          complete: function(){
            mc.css( {
              opacity: 1
            });
            afterFadeoutCallback();
          }
         });
      }
    })
}

function containerSkewOpen( menuContainer, beforeDropCallback = null, afterDropCallback = null ) {

  if( beforeDropCallback != null ) {
    if(( beforeDropCallback.then || null ) == null ){
      beforeDropCallback().then( function(){
        containerSkewClose( menuContainer, null, afterDropCallback );
      }.bind(this));
      return; 
    } else {
      beforeDropCallback();
    }
  }
  const mc   = menuContainer;
  const y   = window.innerHeight;
  const x   = window.innerWidth;
  const deg =  ( 90 -Math.atan2(y,x)/Math.PI*180 );
  const initialMenuPos = Math.floor( y / 2 );
  const left = ( x  - lineWidth ) / 2 

  mc.css({
      transformOrigin: "top left",
      "width": lineWidth + "px",
      "height": "0%",
      "opacity":1,
      "left": "0px",
      "top": "0px"
  });
  mc.get(0).style['transformOrigin'] = "top left";
  // mi[0].style.transform = 'skewX(' + -1 * deg + 'deg)';
  console.log( 'skewX(' + deg + 'deg)' );
  mc[0].style.transform =  'skewX(' + deg + 'deg)';
  // mc.css({transformOrigin: "top right"});
  mc.velocity('stop').velocity(
    { 
       "height": "100%"
    },{
      duration: 400,
      easing: 'easeInCirc',
      complete: function(){
        mc.get(0)['transformOrigin'] = "center center";
        //mc.get(0)['left']           = left + "px";
        mc.css({left: left + "px"});
        setTimeout( function(){
          mc.velocity('stop').velocity(
            { 
              "left":  Math.floor( ( -1*x ) )+"px",
              "width": "300%"
            },{
              duration: 500,
              easing: 'easeInCirc',
              complete: function(){
                mc.css({
                  "width": "100%",
                  "left":  "0px",
                  "height": "100%",
                  "top": "0px"
                });
                mc[0].style.transform =  null;
                mc.css({'transform-origin': ''});
                mc.velocity('stop', 'true');
                if( afterDropCallback ) {
                  afterDropCallback();
                }

              }
            }
          );
        },10);
      }
    }
  );

}

export {
  prepareTypingEffect,
  containerSkewFadeout,
  containerSkewOpen,
  containerSkewClose
};
